import React, { createContext, useReducer } from 'react'
import { getInitialState } from '../InitialState/inititialState'
import permissionReducer from '../reducer/Authorization/permissionReducer'
import moduleAdminReducer from '../reducer/moduleAdminReducer'

export const CompanyConfigContext = createContext({})

export const CompanyConfigContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(permissionReducer, getInitialState('permissions'))

  console.log({ state })
  const [moduleAdminState, moduleAdminDispatch] = useReducer(moduleAdminReducer, getInitialState('moduleAdmins'))

  function getAllPermissions(data) {
    console.log({ PeR_DATA: data })
    dispatch({
      type: 'GET_ALL_PERMISSIONS',
      payload: data,
    })
  }

  function deletePermission(id) {
    dispatch({
      type: 'DELETE_PERMISSION',
      payload: id,
    })
  }
  function getAllModuleAdmins(data) {
    moduleAdminDispatch({
      type: 'GET_ALL_MODULEADMINS',
      payload: data,
    })
  }

  function deleteModuleAdmin(id) {
    moduleAdminDispatch({
      type: 'DELETE_MODULEADMIN',
      payload: id,
    })
  }

  return (
    <CompanyConfigContext.Provider
      value={{
        getNewPermissions: getAllPermissions,
        deleteNewPermission: deletePermission,
        permissions: state.permissions,
        getNewModuleAdmins: getAllModuleAdmins,
        deleteNewModuleAdmin: deleteModuleAdmin,
        moduleAdmins: moduleAdminState.moduleAdmins,
      }}
    >
      {children}
    </CompanyConfigContext.Provider>
  )
}
